import React from 'react';
import { withRouter } from 'react-router-dom';
import cn from "classnames";
import {formatDateTime} from "../../../utils/formatDateTime";
import swal from "sweetalert";
import {useDispatch} from "react-redux";
import ActionMenu from "../../../components/utils/ActionMenu";
import { deleteWriteoff } from '../../../action/writeoff';
import { getLastInventory } from '../../../action';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { parseNumToFixed } from '../../../utils/common';

const renderAdress = (point) => {
    if (!point) return 'Адрес не указан';
    const cityName = point.city ? point.city.name : 'Город не указан';
    const street = point.street ? point.street : 'Улица не указана';
    const house = point.house ? point.house : '';

    return `${cityName}, ${street} ${house}`;
};

const Item = ({ item, history }) => {
    const dispatch = useDispatch();

    const fullAddress = renderAdress(item.point);

    const openEdit = async () => {
        const lastInventory = await dispatch(getLastInventory(item.point));
        if (lastInventory && lastInventory.error) {
            return swal({
                title: `Редактирование невозможно`,
                text: lastInventory.error.message || '',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };
        if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(item.date)) {
            return swal({
                title: `Редактирование невозможно`,
                text: 'Была проведена инвентаризация',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        }
        history.push(`/accounting/writeoff/edit/${item.id}`)
    }

    const onDeleteWriteOff = async () => {
        const lastInventory = await dispatch(getLastInventory(item.point));

        if (lastInventory && lastInventory.error) {
            return swal({
                title: `Удаление невозможно`,
                text: lastInventory.error.message || '',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };

        if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(item.date)) {
            return swal({
                title: `Удаление невозможно`,
                text: 'Была проведена инвентаризация',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        }

        const street = item.point && item.point.street ? item.point.street : 'Адрес неизвестен';
        const house = item.point && item.point.house ? item.point.house : '';

        swal({
            title: `Удаление списания`,
            text: `Вы действительно котите удалить списание № ${item.id} по филиалу ${street} ${house}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteWriteoff(item.id))
                    .then(() => {
                        swal("Успех!", "Списание была успешно удалена.", "success");
                    })
                    .catch(() => {});
            }
        });
    }

    const actions = [
        { name: 'Просмотр', icon: 'la la-eye', action: () => history.push(`/accounting/writeoff/detail/${item.id}`) },
        { name: 'Редактировать', icon: 'la la-edit', action: () => openEdit() },
        { name: 'Удалить', icon: 'la la-trash', action: () => onDeleteWriteOff()},

    ];

    if (window.innerWidth > 730) {
        return (
            <tr key={`${item.id}_item`} className="kt-datatable__row">
                <td width="165px" className="kt-datatable__cell">
                    <span>{formatDateTime(item.date)}</span>
                </td>
                <td style={{ textAlign: 'center' }} width="120px" className="kt-datatable__cell">
                    <span>{item.writeoffreason ? item.writeoffreason.name : 'Не указано'}</span>
                </td>
                <td width="330px" className="kt-datatable__cell">
                    <span>{fullAddress}</span>
                </td>
                <td width="auto" className="kt-datatable__cell">
                    <span>{item.note}</span>
                </td>
                <td style={{ textAlign: 'center' }} width="165px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.totalSum)}</span>
                </td>
                <td align="right" width="180px" className="kt-datatable__cell">
                    <button
                        data-tip="Просмотр"
                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                        onClick={() => history.push(`/accounting/writeoff/detail/${item.id}`)}
                    >
                        <i className="la la-eye"></i>
                    </button>
                    <button
                        data-tip="Редактирование"
                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                        onClick={openEdit}
                    >
                        <i className="la la-edit"></i>
                    </button>
                    <button
                        data-tip="Удалить"
                        className={cn("btn btn-sm btn-clean btn-icon btn-icon-md")}
                        onClick={onDeleteWriteOff}
                    >
                        <i className="la la-trash"></i>
                    </button>
                </td>
            </tr>
        );
    }

    return (
        <tr key={`${item.id}_item`} className="kt-datatable__row">
            <td colSpan="6">
                <div className='mobile_div_flex column padding10px'>
                    <div className='mobile_div_flex column_mobile430px'>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>{fullAddress}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>{formatDateTime(item.date)}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>Причина: {item.writeoffreason ? item.writeoffreason.name : 'Не указано'}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>Сумма: {parseNumToFixed(item.totalSum)}</span>
                        </div>
                    </div>
                    <div className='mobile_div_flex' style={{ justifyContent: 'flex-end', marginTop: 10 }}>
                        <div className="action-buttons">
                            <ActionMenu actions={actions} />
                        </div>
                    </div>
                </div>
            </td>
        </tr>
        )
};

export const ItemRow = withRouter(Item);
